import { queryOptions, useQuery } from '@tanstack/react-query'
import { validatePerimeterPreconditions } from '../../services/farmMapping/perimeter/validatePerimeterPreconditions'
import { queryKeys } from './queryKeys'

// PerimeterHome checks the preconditions from inside processValidation's doAction — an
// imperative callback where a hook cannot be called — so the read is exposed as options
// fetchQuery can take, keeping that call site on the same cache entry as any declarative reader.
export const perimeterPreconditionsQueryOptions = ({
  farmId,
  overrideEdition,
}: {
  farmId: string
  overrideEdition: boolean
}) =>
  queryOptions({
    queryKey: queryKeys.perimeterPreconditions(farmId, overrideEdition),
    queryFn: ({ signal }) =>
      validatePerimeterPreconditions({ id: farmId, overrideEdition, signal }),
    // The backend re-evaluates site counts, statement status and the monitoring plan on
    // every call, and none of the keys that change those cascade into this one, so the
    // global 60s stale window would gate the check on a stale answer.
    staleTime: 0,
  })

export const usePerimeterPreconditions = ({
  farmId,
  overrideEdition,
}: {
  farmId: string | undefined
  overrideEdition: boolean
}) =>
  useQuery({
    ...perimeterPreconditionsQueryOptions({ farmId: farmId as string, overrideEdition }),
    enabled: !!farmId,
  })
